/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-28 16:08:27
 *
 *******************************************************/
// @flow
import type { Action } from './store.type';
import type { FilterSettingsType } from 'src/models/filter-settings';

export const GET_FILTER_SETTINGS_REQUEST = 'GET_FILTER_SETTINGS_REQUEST';
type GET_FILTER_SETTINGS_REQUEST_TYPE = 'GET_FILTER_SETTINGS_REQUEST';

export const GET_FILTER_SETTINGS_SUCCESS = 'GET_FILTER_SETTINGS_SUCCESS';
type GET_FILTER_SETTINGS_SUCCESS_TYPE = 'GET_FILTER_SETTINGS_SUCCESS';

export const GET_FILTER_SETTINGS_FAILURE = 'GET_FILTER_SETTINGS_FAILURE';
type GET_FILTER_SETTINGS_FAILURE_TYPE = 'GET_FILTER_SETTINGS_FAILURE';

export const UPDATE_FILTER_SETTINGS_REQUEST = 'UPDATE_FILTER_SETTINGS_REQUEST';
type UPDATE_FILTER_SETTINGS_REQUEST_TYPE = 'UPDATE_FILTER_SETTINGS_REQUEST';

export const UPDATE_FILTER_SETTINGS_SUCCESS = 'UPDATE_FILTER_SETTINGS_SUCCESS';
type UPDATE_FILTER_SETTINGS_SUCCESS_TYPE = 'UPDATE_FILTER_SETTINGS_SUCCESS';

export const UPDATE_FILTER_SETTINGS_FAILURE = 'UPDATE_FILTER_SETTINGS_FAILURE';
type UPDATE_FILTER_SETTINGS_FAILURE_TYPE = 'UPDATE_FILTER_SETTINGS_FAILURE';

export const CLEAR_CACHE_FILTER_SETTINGS_REQUEST = 'CLEAR_CACHE_FILTER_SETTINGS_REQUEST';
type CLEAR_CACHE_FILTER_SETTINGS_REQUEST_TYPE = 'CLEAR_CACHE_FILTER_SETTINGS_REQUEST';

export const CLEAR_CACHE_FILTER_SETTINGS_SUCCESS = 'CLEAR_CACHE_FILTER_SETTINGS_SUCCESS';
type CLEAR_CACHE_FILTER_SETTINGS_SUCCESS_TYPE = 'CLEAR_CACHE_FILTER_SETTINGS_SUCCESS';

export const CLEAR_CACHE_FILTER_SETTINGS_FAILURE = 'CLEAR_CACHE_FILTER_SETTINGS_FAILURE';
type CLEAR_CACHE_FILTER_SETTINGS_FAILURE_TYPE = 'CLEAR_CACHE_FILTER_SETTINGS_FAILURE';

type FilterSettingsSuccess = {
  data: FilterSettingsType
};

type FilterSettingsFailure = {
  error: any
};

type GetFilterSettingsRequestAction = Action<GET_FILTER_SETTINGS_REQUEST_TYPE, null>;

type GetFilterSettingsSuccessAction = Action<
  GET_FILTER_SETTINGS_SUCCESS_TYPE,
  { data: FilterSettingsSuccess, adminAppDisplay: Object }
>;

type GetFilterSettingsFailureAction = Action<
  GET_FILTER_SETTINGS_FAILURE_TYPE,
  FilterSettingsFailure
>;

type UpdateFilterSettingsRequestAction = Action<UPDATE_FILTER_SETTINGS_REQUEST_TYPE, null>;

type UpdateFilterSettingsSuccessAction = Action<
  UPDATE_FILTER_SETTINGS_SUCCESS_TYPE,
  { data: FilterSettingsSuccess, suggestionsList: Object, adminAppDisplay: Object }
>;

type UpdateFilterSettingsFailureAction = Action<
  UPDATE_FILTER_SETTINGS_FAILURE_TYPE,
  FilterSettingsFailure
>;

type ClearCacheFilterSettingsRequestAction = Action<CLEAR_CACHE_FILTER_SETTINGS_REQUEST_TYPE, null>;

type ClearCacheFilterSettingsSuccessAction = Action<
  CLEAR_CACHE_FILTER_SETTINGS_SUCCESS_TYPE,
  { data: FilterSettingsSuccess }
>;

type ClearCacheFilterSettingsFailureAction = Action<
  CLEAR_CACHE_FILTER_SETTINGS_FAILURE_TYPE,
  FilterSettingsFailure
>;

export type FilterSettingsAction =
  | GetFilterSettingsRequestAction
  | GetFilterSettingsSuccessAction
  | GetFilterSettingsFailureAction
  | UpdateFilterSettingsRequestAction
  | UpdateFilterSettingsSuccessAction
  | UpdateFilterSettingsFailureAction
  | ClearCacheFilterSettingsRequestAction
  | ClearCacheFilterSettingsSuccessAction
  | ClearCacheFilterSettingsFailureAction;

export type FilterSettingsState = {
  loadingFilterSettings: boolean,
  savingFilterSettings: boolean,
  loadingClearCache: boolean,
  success: boolean,
  successSave: boolean,
  successClearCache: boolean,
  error: any,
  filterSettings: FilterSettingsType | {},
  adminAppDisplay: Object
};
